"use client";

import { PageContainer } from "@repo/ui/components/page-container";
import { usePathname } from "next/navigation";

import type { Metal } from "../../../../lib/api-client";
import { METALS } from "../../../../lib/store-href";
import { ProductSkeleton, StoreSkeleton } from "../../_components/PageSkeletons";

// One route serves the listings and the product pages (F78), so the skeleton
// follows the address being opened: one segment that isn't a metal or
// "brand" is a product, as in page.tsx's productSlugOf.
export default function StoreLoading() {
  const [, , ...slug] = usePathname().split("/");
  const [only] = slug;
  const isProduct = slug.length === 1 && !!only && only !== "brand" && !METALS.includes(only as Metal);
  return <PageContainer>{isProduct ? <ProductSkeleton /> : <StoreSkeleton />}</PageContainer>;
}
